import { gql } from "lib/apolloClient";

export const validateTranscriptV3BulkUploadFromExcelMutation = gql`
  mutation validateTranscriptV3BulkUploadFromExcel(
    $input: ValidateTranscriptV3BulkUploadInput!
  ) {
    transcript {
      validateTranscriptV3BulkUploadFromExcel(input: $input) {
        isSuccess
        transactionId
        error
        summary {
          totalCount
          updatedCount
          createdCount
          skippedCount
        }
      }
    }
  }
`;

export const commitTranscriptV3BulkUploadFromExcelMutation = gql`
  mutation commitTranscriptV3BulkUploadFromExcel(
    $input: CommitTranscriptV3BulkUploadInput!
  ) {
    transcript {
      commitTranscriptV3BulkUploadFromExcel(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
